module.exports = __webpack_public_path__ + "static/media/cornerMatBlue35.039ea677.png";